// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-micro-left';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M10 11.585v-5.17c0-.31-.147-.517-.265-.362L7.11 8.638a.654.654 0 0 0-.059.62c.03.052.03.104.06.104l2.624 2.585c.118.155.265-.051.265-.362z'
  />
);

export const viewBox = '0 0 18 18';
